import React from "react";
import LoadingScreen from "../LoadingScreen";
import NotAuthorizedComponent from "../NotAuthorizedComponent";
import { useOidcUser } from "./oidc/useOidcUser";

export function withUserOIDC(WrappedComponent) {
  function WithUserWrapper(props) {
    const { user, setUser, isAuthenticated, isLoading, error } = useOidcUser();

    if (isLoading) {
      return <LoadingScreen />;
    }

    if (error || !isAuthenticated) {
      return (
        <NotAuthorizedComponent
          message={error?.message || "Authentication failed"}
          redirectUrl="/login"
        />
      );
    }

    return (
      <WrappedComponent
        user={user}
        setUser={setUser}
        isAuthenticated={isAuthenticated}
        {...props}
      />
    );
  }

  WithUserWrapper.displayName = `withUserOIDC(${
    WrappedComponent.displayName || WrappedComponent.name || "Component"
  })`;

  return WithUserWrapper;
}
